import PairItemContainer from '../../ui/pairItemContainer/PairItemContainer';
import { MainSectionWrapper } from '../mainSectionWrapper';
import { TitleSectionWrapper } from '../titleSectionWrapper/TitleSectionWrapper';
import stylesPending from '../mainContentPending/MainContentPending.module.css';
import styles from './MainContentBlockPending.module.css';

export const MainContentBlockPending = (props) => {
    return (
        <div
            className={stylesPending.MainContentPending}
            data-testid={props['data-testid']}
        >
            <TitleSectionWrapper>
                <div className={stylesPending.pendingItem} />
            </TitleSectionWrapper>
            <MainSectionWrapper>
                <PairItemContainer className={styles.PairItemContainerPending}>
                    <div className={styles.summaryContainer}>
                        <div className={stylesPending.longPendingItem} />
                        <div className={stylesPending.smallPendingItem} />
                    </div>
                    <div className={styles.repaymentSummary}>
                        <div className={stylesPending.longPendingItem} />
                        <div className={stylesPending.smallPendingItem} />
                    </div>
                </PairItemContainer>
            </MainSectionWrapper>
        </div>
    );
};
